const container = document.querySelector("#sliderContainer");
let slideBy = window.innerWidth <= 750 ? 360 : 600;

function calcColourSlides() {
  const childNodes = container
    .querySelector(".lr-color-picker")
    .querySelectorAll("a");
  // If colour picker container width is greater than X, fit all colours onto clients screen
  if (container.clientWidth >= 1100) {
    const totalColours =
      container.querySelector(".lr-color-picker").childElementCount;
    const childWidth = container.clientWidth / totalColours;
    childNodes.forEach((node) => {
      node.querySelector("div").style.width = `${childWidth}px`;
    });
  }
  // If colour picker container width is now less than X, change colour divs to correct size.
  else if (childNodes[0].clientWidth !== 120) {
    childNodes.forEach((node) => {
      node.querySelector("div").style.width = "120px";
    });
  }
}

// If client screen width changes, run function calcColourSlides
const resizeObserver = new ResizeObserver((entries) => calcColourSlides());
resizeObserver.observe(container);

const button = document.querySelector("#slideForward");
button.onclick = function () {
  const container = document.querySelector("#sliderContainer");
  sideScroll(container, "right", 25, slideBy, 20);
};

const back = document.querySelector("#slideBack");
back.onclick = function () {
  sideScroll(container, "left", 25, slideBy, 20);
};

function sideScroll(element, direction, speed, distance, step) {
  scrollAmount = 0;
  const slideTimer = setInterval(function () {
    if (direction == "left") {
      element.scrollLeft -= step;
    } else {
      element.scrollLeft += step;
    }
    scrollAmount += step;

    if (scrollAmount >= distance) {
      window.clearInterval(slideTimer);
    }
  }, speed);
}
